import { useEffect } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { PreferencesType } from "../../types/account/type";
import { useUpdateUserPreferenceMutation } from "../../react-query/user/mutations";
import { preferenceState } from "../../recoil/preference/preferenceAtom";
import { loadFromLocalStorage } from "../../utils/localStorage/localStorage";
import { PREFERENCE_KEY } from "../../services/preference/localStorage";
import { migrateOldPreferences } from "../../services/preference/migrateOldPreferences";
import _ from "lodash";

/**
 * 초기 로드 시: 로컬 → 서버 동기화
 * 이후: 서버 → 로컬 동기화
 */
export const usePreferenceSync = () => {
  const preference = useRecoilValue(preferenceState);
  const setPreference = useSetRecoilState(preferenceState);
  const { mutate: updateUserPreference } = useUpdateUserPreferenceMutation();

  // 실제 로컬스토리지에 preference가 있는지 확인
  const getCurrentPreference = () => loadFromLocalStorage<PreferencesType>(PREFERENCE_KEY);

  // 최초 1회 migration 체크
  useEffect(() => {
    const currentPreference = getCurrentPreference();
    if (!currentPreference) {
      const oldPreference = migrateOldPreferences();
      if (oldPreference) {
        updateUserPreference(oldPreference);
        setPreference(oldPreference);
      }
    }
  }, []);

  return (serverPreference?: PreferencesType) => {
    if (!serverPreference) return;

    // 서버 데이터와 현재 preference가 다른 경우 업데이트 (프로퍼티 순서 무관)
    if (!_.isEqual(serverPreference, preference)) {
      setPreference(serverPreference);
    }
  };
};
